import { SharedUserAccess } from 'app/components/access-sharing/cards';
import { AccessSharingRole } from 'types/entities/AccessSharingRole';

export const dummyEquipmentData: any[] = [
  // {
  //   id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc1',
  //   role: AccessSharingRole.Viewer,
  //   isSharedIndividually: false,
  //   isSharedAsPartOfFleet: false,
  //   nickName: 'Viewer, not shared',
  //   model: 'SVL97-2',
  //   type: 'machine',
  //   modelIconUrl:
  //     'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  // },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc2',
    role: AccessSharingRole.Viewer,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: false,
    nickName: 'Viewer, shared individually',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc3',
    role: AccessSharingRole.Viewer,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: true,
    nickName: 'Viewer, fully shared',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  // {
  //   id: '157ce26f-07b7-4a1a-b8bc-6424d80d7d44',
  //   role: AccessSharingRole.Editor,
  //   isSharedIndividually: false,
  //   isSharedAsPartOfFleet: false,
  //   nickName: 'Editor, not shared',
  //   model: 'SVL97-2',
  //   type: 'machine',
  //   modelIconUrl:
  //     'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  // },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc5',
    role: AccessSharingRole.Editor,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: false,
    nickName: 'Editor, shared individually',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc6',
    role: AccessSharingRole.Editor,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: true,
    nickName: 'Editor, fully shared',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  // {
  // id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc7',
  //   role: AccessSharingRole.Admin,
  //   isSharedIndividually: false,
  //   isSharedAsPartOfFleet: false,
  //   nickName: 'Admin, not shared',
  //   model: 'SVL97-2',
  //   type: 'machine',
  //   modelIconUrl:
  //     'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  // },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc8',
    role: AccessSharingRole.Admin,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: false,
    nickName: 'Admin, shared individually',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7dc9',
    role: AccessSharingRole.Admin,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: true,
    nickName: 'Admin, fully shared',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7d10',
    role: AccessSharingRole.Owner,
    isSharedIndividually: false,
    isSharedAsPartOfFleet: false,
    nickName: 'Owner, not shared',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7d11',
    role: AccessSharingRole.Owner,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: false,
    nickName: 'Owner, shared individually',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
  {
    id: '157ce26f-07b7-4a1a-b8bc-6424d80d7d12',
    role: AccessSharingRole.Owner,
    isSharedIndividually: true,
    isSharedAsPartOfFleet: true,
    nickName: 'Owner, fully shared',
    model: 'SVL97-2',
    type: 'machine',
    modelIconUrl:
      'https://ktcictstorage.z13.web.core.windows.net/images/SVL97-2small.png',
  },
];

export const dummyFleetsData: any[] = [
  {
    id: '1',
    name: 'Arizona Tractors',
    pieces: 24,
    role: AccessSharingRole.Viewer,
    owner: 'Bronn',
    email: 'bronn@gmail.com',
    sharedWithUsers: 3,
  },
  {
    id: '2',
    name: 'Texas Group',
    pieces: 12,
    role: AccessSharingRole.Editor,
    owner: 'Shae',
    email: 'shae@gmail.com',
    sharedWithUsers: 4,
  },
  {
    id: '3',
    name: 'Huston Farm',
    pieces: 3,
    role: AccessSharingRole.Admin,
    owner: 'Loras',
    email: 'loras@gmail.com',
    sharedWithUsers: 2,
  },
  {
    id: '4',
    name: 'Corn Fields',
    pieces: 10,
    role: AccessSharingRole.Owner,
    owner: 'Gendry',
    email: 'gendry@gmail.com',
    sharedWithUsers: 3,
  },
];

export const dummyUserAccess: SharedUserAccess[] = [
  {
    id: 1,
    firstName: 'Nicolas',
    lastName: 'Mooney',
    email: 'nicolas.mooney@mail.com',
    role: AccessSharingRole.Admin,
    startTime: 'March 25, 2024 09:30 AM',
    endTime: 'March 25, 2024 09:30 AM',
  },
  {
    id: 2,
    firstName: 'Aine',
    lastName: 'Knapp',
    email: 'aine.knapp@mail.com',
    role: AccessSharingRole.Editor,
  },
  {
    id: 3,
    firstName: 'Jemima',
    lastName: 'Clark',
    email: 'jemima.clark@mail.com',
    role: AccessSharingRole.Viewer,
    endTime: 'March 25, 2024 09:30 AM',
  },
  {
    id: 4,
    firstName: 'Walter',
    lastName: 'Lee',
    email: 'walter.lee@mail.com',
    role: AccessSharingRole.Admin,
    startTime: 'March 25, 2024 09:30 AM',
    endTime: 'March 25, 2024 09:30 AM',
  },
  {
    id: 5,
    firstName: 'Hilton',
    lastName: 'Schramm',
    email: 'hilton.schramm@mail.com',
    role: AccessSharingRole.Editor,
    endTime: 'March 25, 2024 09:30 AM',
  },
];
